/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConsigneeToursArrayV3 } from '../../models/consignee-tours-array-v-3';
import { ConsigneeToursFilterProperties } from '../../models/consignee-tours-filter-properties';
import { KeyType } from '../../models/key-type';
import { SortType } from '../../models/sort-type';

export interface GetConsigneeToursV3$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;

/**
 * Array of organization site keys to fetch data from (max 1000). If provided, overrides the path parameter.
 */
  organizationSiteKeys?: Array<KeyType>;

/**
 * Maximum number of items to return
 */
  limit?: number;

/**
 * Number of items to skip
 */
  offset?: number;

/**
 * Sort direction (asc or desc)
 */
  sort?: SortType;

/**
 * Field to sort by for tours
 */
  sortBy?: 'dateCreated' | 'dateClosed' | 'checkoutDate' | 'tourNumber' | 'externalTourName' | 'status' | 'consignorName' | 'consigneeName' | 'carrierName';

/**
 * Field to filter consignee tours by
 *
 * @deprecated
 */
  filterProperty?: ConsigneeToursFilterProperties;

/**
 * Value to filter by (partial match)
 *
 * @deprecated
 */
  filterValue?: string;

/**
 * Case-insensitive partial match using the existing status field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  status?: string;

/**
 * Case-insensitive partial match using the existing tourNumber field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  tourNumber?: string;

/**
 * Case-insensitive partial match using the existing externalTourName field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  externalTourName?: string;

/**
 * Case-insensitive partial match using the existing carrierKey field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  carrierKey?: string;

/**
 * Case-insensitive partial match using the existing carrierName field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  carrierName?: string;

/**
 * Case-insensitive partial match using the existing dateClosed field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  dateClosed?: string;

/**
 * Case-insensitive partial match using the existing dateCreated field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  dateCreated?: string;

/**
 * Case-insensitive partial match using the existing checkoutDate field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  checkoutDate?: string;

/**
 * Filter for not closed items only (bundles, tours, delivery notes)
 */
  filterNotClosed?: boolean;

/**
 * Case- and accent-insensitive substring search across all text fields
 * of the entity (numbers, names, file names, date strings). Minimum 3
 * characters. Can be combined with filterProperty/filterValue (results
 * must match both). Search results are eventually consistent: newly
 * written documents can take about one second to appear.
 */
  search?: string;
}

export function getConsigneeToursV3(http: HttpClient, rootUrl: string, params: GetConsigneeToursV3$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsigneeToursArrayV3>> {
  const rb = new RequestBuilder(rootUrl, getConsigneeToursV3.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.query('organizationSiteKeys', params.organizationSiteKeys, {});
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
    rb.query('sort', params.sort, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('filterProperty', params.filterProperty, {});
    rb.query('filterValue', params.filterValue, {});
    rb.query('status', params.status, {});
    rb.query('tourNumber', params.tourNumber, {});
    rb.query('externalTourName', params.externalTourName, {});
    rb.query('carrierKey', params.carrierKey, {});
    rb.query('carrierName', params.carrierName, {});
    rb.query('dateClosed', params.dateClosed, {});
    rb.query('dateCreated', params.dateCreated, {});
    rb.query('checkoutDate', params.checkoutDate, {});
    rb.query('filterNotClosed', params.filterNotClosed, {});
    rb.query('search', params.search, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConsigneeToursArrayV3>;
    })
  );
}

getConsigneeToursV3.PATH = '/organization-sites/{organizationSiteKey}/consignee/tours';
